import Pagination from 'react-bootstrap/Pagination';

function BlogPagination({ currentPage, totalPages, onPageChange }) {
    if (totalPages <= 1) {
        return null;
    }

    const visiblePages = new Set([1, totalPages]);
    for (let page = Math.max(1, currentPage - 1); page <= Math.min(totalPages, currentPage + 1); page += 1) {
        visiblePages.add(page);
    }

    const pages = [...visiblePages].sort((first, second) => first - second);
    const items = [];

    pages.forEach((page, index) => {
        if (index > 0 && page - pages[index - 1] > 1) {
            items.push(<Pagination.Ellipsis key={`ellipsis-${page}`} disabled />);
        }
        items.push(
            <Pagination.Item
                key={page}
                active={page === currentPage}
                onClick={() => onPageChange(page)}
                aria-label={`Go to page ${page}`}
                aria-current={page === currentPage ? 'page' : undefined}
            >
                {page}
            </Pagination.Item>
        );
    });

    return (
        <Pagination aria-label="Blog pages" className="justify-content-center">
            <Pagination.First
                disabled={currentPage === 1}
                onClick={() => onPageChange(1)}
                aria-label="First page"
            />
            <Pagination.Prev
                disabled={currentPage === 1}
                onClick={() => onPageChange(currentPage - 1)}
                aria-label="Previous page"
            />
            {items}
            <Pagination.Next
                disabled={currentPage === totalPages}
                onClick={() => onPageChange(currentPage + 1)}
                aria-label="Next page"
            />
            <Pagination.Last
                disabled={currentPage === totalPages}
                onClick={() => onPageChange(totalPages)}
                aria-label="Last page"
            />
        </Pagination>
    );
}

export default BlogPagination;